class ChannelService {
  constructor() {
    this.windowRef = window;
    this.loadScript();
  }

  loadScript() {
    const w = this.windowRef;
    if (w.ChannelIO) {
      return (w.console.error || w.console.log || function() {})('ChannelIO script included twice.');
    }
    const ch = (...args) => {
      ch.q.push(args);
    };
    ch.q = [];
    w.ChannelIO = ch;

    const l = () => {
      if (w.ChannelIOInitialized) {
        return;
      }
      w.ChannelIOInitialized = true;
      const s = document.createElement('script');
      s.type = 'text/javascript';
      s.async = true;
      s.src = 'https://cdn.channel.io/plugin/ch-plugin-web.js';
      s.charset = 'UTF-8';
      const x = document.getElementsByTagName('script')[0];
      x.parentNode.insertBefore(s, x);
    };

    if (document.readyState === 'complete') {
      l();
    } else if (w.attachEvent) {
      w.attachEvent('onload', l);
    } else {
      w.addEventListener('DOMContentLoaded', l, false);
      w.addEventListener('load', l, false);
    }
    return null; // To handle the consistent-return error
  }

  boot(settings) {
    this.windowRef.ChannelIO('boot', settings);
  }

  shutdown() {
    this.windowRef.ChannelIO('shutdown');
  }
}

export default new ChannelService();
